import { Component, Inject, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'moment';

@Component({
  selector: 'app-forum-dialog',
  templateUrl: './forum-dialog.html',
  styleUrls: [ './forum-dialog.scss' ],
  providers: [ AngularFireDatabase ]
})
export class ForumDialogComponent implements OnInit {
  question : any = {};
  forumRef : any;
  topics : Observable<any>;

  constructor (
    public dialogRef : MatDialogRef<ForumDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any,
    private db: AngularFireDatabase
  ) { }

  ngOnInit() {
    this.forumRef = this.db.list('discussions/');
    this.topics = this.db.list('topics/', ref => ref.orderByChild('title')).snapshotChanges()
    .map(changes => {
      return changes.map(c => ({ key: c.key, ...c.payload.val() }));
    });;
  }

  setTopic(topic) {
    this.question.topicId = topic.key;
  }

  sendQuestion() {
    this.question.date = moment().format('YYYY-MM-DD HH:mm:ss');
    this.question.userId = this.data.user.uid;

    this.forumRef.push(this.question)
      .then(result => {
        this.dialogRef.close(result);
      });
  }
}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/forum/forum-dialog/forum-dialog.component.ts